// TODO: This is a copy from Journey - remove when
// Alpha 3 is available in pro
export const countriesMap = [
    {
        "Name": "Afghanistan",
        "Alpha3Code": "AFG",
        "Alpha2Code": "AF",
        "VatCode": "AF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 4
    },
    {
        "Name": "Åland Islands",
        "Alpha3Code": "ALA",
        "Alpha2Code": "AX",
        "VatCode": "AX",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 248
    },
    {
        "Name": "Albania",
        "Alpha3Code": "ALB",
        "Alpha2Code": "AL",
        "VatCode": "AL",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 8
    },
    {
        "Name": "Algeria",
        "Alpha3Code": "DZA",
        "Alpha2Code": "DZ",
        "VatCode": "DZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 12
    },
    {
        "Name": "American Samoa",
        "Alpha3Code": "ASM",
        "Alpha2Code": "AS",
        "VatCode": "AS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 16
    },
    {
        "Name": "Andorra",
        "Alpha3Code": "AND",
        "Alpha2Code": "AD",
        "VatCode": "AD",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 20
    },
    {
        "Name": "Angola",
        "Alpha3Code": "AGO",
        "Alpha2Code": "AO",
        "VatCode": "AO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 24
    },
    {
        "Name": "Anguilla",
        "Alpha3Code": "AIA",
        "Alpha2Code": "AI",
        "VatCode": "AI",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 660
    },
    {
        "Name": "Antarctica",
        "Alpha3Code": "ATA",
        "Alpha2Code": "AQ",
        "VatCode": "AQ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 10
    },
    {
        "Name": "Antigua and Barbuda",
        "Alpha3Code": "ATG",
        "Alpha2Code": "AG",
        "VatCode": "AG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 28
    },
    {
        "Name": "Argentina",
        "Alpha3Code": "ARG",
        "Alpha2Code": "AR",
        "VatCode": "AR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 32
    },
    {
        "Name": "Armenia",
        "Alpha3Code": "ARM",
        "Alpha2Code": "AM",
        "VatCode": "AM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 51
    },
    {
        "Name": "Aruba",
        "Alpha3Code": "ABW",
        "Alpha2Code": "AW",
        "VatCode": "AW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 533
    },
    {
        "Name": "Australia",
        "Alpha3Code": "AUS",
        "Alpha2Code": "AU",
        "VatCode": "AU",
        "HasVat": true,
        "TaxRate": 0.1,
        "Currency": "AUD",
        "ShowVatField": false,
        "AlwaysChargeVat": true,
        "Id": 36
    },
    {
        "Name": "Austria",
        "Alpha3Code": "AUT",
        "Alpha2Code": "AT",
        "VatCode": "AT",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.2,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 40
    },
    {
        "Name": "Azerbaijan",
        "Alpha3Code": "AZE",
        "Alpha2Code": "AZ",
        "VatCode": "AZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 31
    },
    {
        "Name": "Bahamas",
        "Alpha3Code": "BHS",
        "Alpha2Code": "BS",
        "VatCode": "BS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 44
    },
    {
        "Name": "Bahrain",
        "Alpha3Code": "BHR",
        "Alpha2Code": "BH",
        "VatCode": "BH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 48
    },
    {
        "Name": "Bangladesh",
        "Alpha3Code": "BGD",
        "Alpha2Code": "BD",
        "VatCode": "BD",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 50
    },
    {
        "Name": "Barbados",
        "Alpha3Code": "BRB",
        "Alpha2Code": "BB",
        "VatCode": "BB",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 52
    },
    {
        "Name": "Belarus",
        "Alpha3Code": "BLR",
        "Alpha2Code": "BY",
        "VatCode": "BY",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 112
    },
    {
        "Name": "Belgium",
        "Alpha3Code": "BEL",
        "Alpha2Code": "BE",
        "VatCode": "BE",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.21,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 56
    },
    {
        "Name": "Belize",
        "Alpha3Code": "BLZ",
        "Alpha2Code": "BZ",
        "VatCode": "BZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 84
    },
    {
        "Name": "Benin",
        "Alpha3Code": "BEN",
        "Alpha2Code": "BJ",
        "VatCode": "BJ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 204
    },
    {
        "Name": "Bermuda",
        "Alpha3Code": "BMU",
        "Alpha2Code": "BM",
        "VatCode": "BM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 60
    },
    {
        "Name": "Bhutan",
        "Alpha3Code": "BTN",
        "Alpha2Code": "BT",
        "VatCode": "BT",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 64
    },
    {
        "Name": "Bolivia",
        "Alpha3Code": "BOL",
        "Alpha2Code": "BO",
        "VatCode": "BO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 68
    },
    {
        "Name": "Bonaire",
        "Alpha3Code": "BES",
        "Alpha2Code": "BQ",
        "VatCode": "BQ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 535
    },
    {
        "Name": "Bosnia and Herzegovina",
        "Alpha3Code": "BIH",
        "Alpha2Code": "BA",
        "VatCode": "BA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 70
    },
    {
        "Name": "Botswana",
        "Alpha3Code": "BWA",
        "Alpha2Code": "BW",
        "VatCode": "BW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 72
    },
    {
        "Name": "Bouvet Island",
        "Alpha3Code": "BVT",
        "Alpha2Code": "BV",
        "VatCode": "BV",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 74
    },
    {
        "Name": "Brazil",
        "Alpha3Code": "BRA",
        "Alpha2Code": "BR",
        "VatCode": "BR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 76
    },
    {
        "Name": "British Indian Ocean Territory",
        "Alpha3Code": "IOT",
        "Alpha2Code": "IO",
        "VatCode": "IO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 86
    },
    {
        "Name": "Brunei Darussalam",
        "Alpha3Code": "BRN",
        "Alpha2Code": "BN",
        "VatCode": "BN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 96
    },
    {
        "Name": "Bulgaria",
        "Alpha3Code": "BGR",
        "Alpha2Code": "BG",
        "VatCode": "BG",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.2,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 100
    },
    {
        "Name": "Burkina Faso",
        "Alpha3Code": "BFA",
        "Alpha2Code": "BF",
        "VatCode": "BF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 854
    },
    {
        "Name": "Burundi",
        "Alpha3Code": "BDI",
        "Alpha2Code": "BI",
        "VatCode": "BI",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 108
    },
    {
        "Name": "Cabo Verde",
        "Alpha3Code": "CPV",
        "Alpha2Code": "CV",
        "VatCode": "CV",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 132
    },
    {
        "Name": "Cambodia",
        "Alpha3Code": "KHM",
        "Alpha2Code": "KH",
        "VatCode": "KH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 116
    },
    {
        "Name": "Cameroon",
        "Alpha3Code": "CMR",
        "Alpha2Code": "CM",
        "VatCode": "CM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 120
    },
    {
        "Name": "Canada",
        "Alpha3Code": "CAN",
        "Alpha2Code": "CA",
        "VatCode": "CA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 124
    },
    {
        "Name": "Cayman Islands",
        "Alpha3Code": "CYM",
        "Alpha2Code": "KY",
        "VatCode": "KY",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 136
    },
    {
        "Name": "Central African Republic",
        "Alpha3Code": "CAF",
        "Alpha2Code": "CF",
        "VatCode": "CF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 140
    },
    {
        "Name": "Chad",
        "Alpha3Code": "TCD",
        "Alpha2Code": "TD",
        "VatCode": "TD",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 148
    },
    {
        "Name": "Chile",
        "Alpha3Code": "CHL",
        "Alpha2Code": "CL",
        "VatCode": "CL",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 152
    },
    {
        "Name": "China",
        "Alpha3Code": "CHN",
        "Alpha2Code": "CN",
        "VatCode": "CN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 156
    },
    {
        "Name": "Christmas Island",
        "Alpha3Code": "CXR",
        "Alpha2Code": "CX",
        "VatCode": "CX",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 162
    },
    {
        "Name": "Cocos (Keeling) Islands",
        "Alpha3Code": "CCK",
        "Alpha2Code": "CC",
        "VatCode": "CC",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 166
    },
    {
        "Name": "Colombia",
        "Alpha3Code": "COL",
        "Alpha2Code": "CO",
        "VatCode": "CO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 170
    },
    {
        "Name": "Comoros",
        "Alpha3Code": "COM",
        "Alpha2Code": "KM",
        "VatCode": "KM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 174
    },
    {
        "Name": "Congo",
        "Alpha3Code": "COG",
        "Alpha2Code": "CG",
        "VatCode": "CG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 178
    },
    {
        "Name": "Congo",
        "Alpha3Code": "COD",
        "Alpha2Code": "CD",
        "VatCode": "CD",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 180
    },
    {
        "Name": "Cook Islands",
        "Alpha3Code": "COK",
        "Alpha2Code": "CK",
        "VatCode": "CK",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 184
    },
    {
        "Name": "Costa Rica",
        "Alpha3Code": "CRI",
        "Alpha2Code": "CR",
        "VatCode": "CR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 188
    },
    {
        "Name": "Côte d'Ivoire",
        "Alpha3Code": "CIV",
        "Alpha2Code": "CI",
        "VatCode": "CI",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 384
    },
    {
        "Name": "Croatia",
        "Alpha3Code": "HRV",
        "Alpha2Code": "HR",
        "VatCode": "HR",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.25,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 191
    },
    {
        "Name": "Cuba",
        "Alpha3Code": "CUB",
        "Alpha2Code": "CU",
        "VatCode": "CU",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 192
    },
    {
        "Name": "Curacao",
        "Alpha3Code": "CUW",
        "Alpha2Code": "CW",
        "VatCode": "CW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 531
    },
    {
        "Name": "Cyprus",
        "Alpha3Code": "CYP",
        "Alpha2Code": "CY",
        "VatCode": "CY",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.19,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 196
    },
    {
        "Name": "Czech Republic",
        "Alpha3Code": "CZE",
        "Alpha2Code": "CZ",
        "VatCode": "CZ",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.21,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 203
    },
    {
        "Name": "Denmark",
        "Alpha3Code": "DNK",
        "Alpha2Code": "DK",
        "VatCode": "DK",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.25,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 208
    },
    {
        "Name": "Djibouti",
        "Alpha3Code": "DJI",
        "Alpha2Code": "DJ",
        "VatCode": "DJ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 262
    },
    {
        "Name": "Dominica",
        "Alpha3Code": "DMA",
        "Alpha2Code": "DM",
        "VatCode": "DM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 212
    },
    {
        "Name": "Dominican Republic",
        "Alpha3Code": "DOM",
        "Alpha2Code": "DO",
        "VatCode": "DO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 214
    },
    {
        "Name": "Ecuador",
        "Alpha3Code": "ECU",
        "Alpha2Code": "EC",
        "VatCode": "EC",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 218
    },
    {
        "Name": "Egypt",
        "Alpha3Code": "EGY",
        "Alpha2Code": "EG",
        "VatCode": "EG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 818
    },
    {
        "Name": "El Salvador",
        "Alpha3Code": "SLV",
        "Alpha2Code": "SV",
        "VatCode": "SV",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 222
    },
    {
        "Name": "Equatorial Guinea",
        "Alpha3Code": "GNQ",
        "Alpha2Code": "GQ",
        "VatCode": "GQ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 226
    },
    {
        "Name": "Eritrea",
        "Alpha3Code": "ERI",
        "Alpha2Code": "ER",
        "VatCode": "ER",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 232
    },
    {
        "Name": "Estonia",
        "Alpha3Code": "EST",
        "Alpha2Code": "EE",
        "VatCode": "EE",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.2,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 233
    },
    {
        "Name": "Ethiopia",
        "Alpha3Code": "ETH",
        "Alpha2Code": "ET",
        "VatCode": "ET",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 231
    },
    {
        "Name": "Falkland Islands (Malvinas)",
        "Alpha3Code": "FLK",
        "Alpha2Code": "FK",
        "VatCode": "FK",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 238
    },
    {
        "Name": "Faroe Islands",
        "Alpha3Code": "FRO",
        "Alpha2Code": "FO",
        "VatCode": "FO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 234
    },
    {
        "Name": "Fiji",
        "Alpha3Code": "FJI",
        "Alpha2Code": "FJ",
        "VatCode": "FJ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 242
    },
    {
        "Name": "Finland",
        "Alpha3Code": "FIN",
        "Alpha2Code": "FI",
        "VatCode": "FI",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.24,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 246
    },
    {
        "Name": "France",
        "Alpha3Code": "FRA",
        "Alpha2Code": "FR",
        "VatCode": "FR",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.2,
        "TaxRegion": "FR Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": true,
        "Id": 250
    },
    {
        "Name": "French Guiana",
        "Alpha3Code": "GUF",
        "Alpha2Code": "GF",
        "VatCode": "GF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 254
    },
    {
        "Name": "French Polynesia",
        "Alpha3Code": "PYF",
        "Alpha2Code": "PF",
        "VatCode": "PF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 258
    },
    {
        "Name": "French Southern Territories",
        "Alpha3Code": "ATF",
        "Alpha2Code": "TF",
        "VatCode": "TF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 260
    },
    {
        "Name": "Gabon",
        "Alpha3Code": "GAB",
        "Alpha2Code": "GA",
        "VatCode": "GA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 266
    },
    {
        "Name": "Gambia",
        "Alpha3Code": "GMB",
        "Alpha2Code": "GM",
        "VatCode": "GM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 270
    },
    {
        "Name": "Georgia",
        "Alpha3Code": "GEO",
        "Alpha2Code": "GE",
        "VatCode": "GE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 268
    },
    {
        "Name": "Germany",
        "Alpha3Code": "DEU",
        "Alpha2Code": "DE",
        "VatCode": "DE",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.19,
        "TaxRegion": "DE Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": true,
        "Id": 276
    },
    {
        "Name": "Ghana",
        "Alpha3Code": "GHA",
        "Alpha2Code": "GH",
        "VatCode": "GH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 288
    },
    {
        "Name": "Gibraltar",
        "Alpha3Code": "GIB",
        "Alpha2Code": "GI",
        "VatCode": "GI",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 292
    },
    {
        "Name": "Greece",
        "Alpha3Code": "GRC",
        "Alpha2Code": "GR",
        "VatCode": "EL",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.23,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 300
    },
    {
        "Name": "Greenland",
        "Alpha3Code": "GRL",
        "Alpha2Code": "GL",
        "VatCode": "GL",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 304
    },
    {
        "Name": "Grenada",
        "Alpha3Code": "GRD",
        "Alpha2Code": "GD",
        "VatCode": "GD",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 308
    },
    {
        "Name": "Guadeloupe",
        "Alpha3Code": "GLP",
        "Alpha2Code": "GP",
        "VatCode": "GP",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 312
    },
    {
        "Name": "Guam",
        "Alpha3Code": "GUM",
        "Alpha2Code": "GU",
        "VatCode": "GU",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 316
    },
    {
        "Name": "Guatemala",
        "Alpha3Code": "GTM",
        "Alpha2Code": "GT",
        "VatCode": "GT",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 320
    },
    {
        "Name": "Guernsey",
        "Alpha3Code": "GGY",
        "Alpha2Code": "GG",
        "VatCode": "GG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 831
    },
    {
        "Name": "Guinea",
        "Alpha3Code": "GIN",
        "Alpha2Code": "GN",
        "VatCode": "GN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 324
    },
    {
        "Name": "Guinea-Bissau",
        "Alpha3Code": "GNB",
        "Alpha2Code": "GW",
        "VatCode": "GW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 624
    },
    {
        "Name": "Guyana",
        "Alpha3Code": "GUY",
        "Alpha2Code": "GY",
        "VatCode": "GY",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 328
    },
    {
        "Name": "Haiti",
        "Alpha3Code": "HTI",
        "Alpha2Code": "HT",
        "VatCode": "HT",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 332
    },
    {
        "Name": "Heard Island and McDonald Islands",
        "Alpha3Code": "HMD",
        "Alpha2Code": "HM",
        "VatCode": "HM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 334
    },
    {
        "Name": "Holy See (Vatican City State)",
        "Alpha3Code": "VAT",
        "Alpha2Code": "VA",
        "VatCode": "VA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 336
    },
    {
        "Name": "Honduras",
        "Alpha3Code": "HND",
        "Alpha2Code": "HN",
        "VatCode": "HN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 340
    },
    {
        "Name": "Hong Kong",
        "Alpha3Code": "HKG",
        "Alpha2Code": "HK",
        "VatCode": "HK",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 344
    },
    {
        "Name": "Hungary",
        "Alpha3Code": "HUN",
        "Alpha2Code": "HU",
        "VatCode": "HU",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.27,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 348
    },
    {
        "Name": "Iceland",
        "Alpha3Code": "ISL",
        "Alpha2Code": "IS",
        "VatCode": "IS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 352
    },
    {
        "Name": "India",
        "Alpha3Code": "IND",
        "Alpha2Code": "IN",
        "VatCode": "IN",
        "HasVat": true,
        "TaxRate": 0.18,
        "TaxRegion": "IN Taxable",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 356
    },
    {
        "Name": "Indonesia",
        "Alpha3Code": "IDN",
        "Alpha2Code": "ID",
        "VatCode": "ID",
        "TaxRegion": "SGD Non-Taxable",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 360
    },
    {
        "Name": "Iran",
        "Alpha3Code": "IRN",
        "Alpha2Code": "IR",
        "VatCode": "IR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 364
    },
    {
        "Name": "Iraq",
        "Alpha3Code": "IRQ",
        "Alpha2Code": "IQ",
        "VatCode": "IQ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 368
    },
    {
        "Name": "Ireland",
        "Alpha3Code": "IRL",
        "Alpha2Code": "IE",
        "VatCode": "IE",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.23,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 372
    },
    {
        "Name": "Isle of Man",
        "Alpha3Code": "IMN",
        "Alpha2Code": "IM",
        "VatCode": "IM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 833
    },
    {
        "Name": "Israel",
        "Alpha3Code": "ISR",
        "Alpha2Code": "IL",
        "VatCode": "IL",
        "HasVat": true,
        "HasCompanyId": true,
        "TaxRate": 0.18,
        "TaxRegion": "IL Taxable",
        "Currency": "ILS",
        "ShowVatField": true,
        "AlwaysChargeVat": true,
        "Id": 376
    },
    {
        "Name": "Italy",
        "Alpha3Code": "ITA",
        "Alpha2Code": "IT",
        "VatCode": "IT",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.22,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 380
    },
    {
        "Name": "Jamaica",
        "Alpha3Code": "JAM",
        "Alpha2Code": "JM",
        "VatCode": "JM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 388
    },
    {
        "Name": "Japan",
        "Alpha3Code": "JPN",
        "Alpha2Code": "JP",
        "VatCode": "JP",
        "HasVat": true,
        "TaxRate": 0.1,
        "TaxRegion": "JP Taxable",
        "Currency": "JPY",
        "ShowVatField": false,
        "AlwaysChargeVat": true,
        "Id": 392
    },
    {
        "Name": "Jersey",
        "Alpha3Code": "JEY",
        "Alpha2Code": "JE",
        "VatCode": "JE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 832
    },
    {
        "Name": "Jordan",
        "Alpha3Code": "JOR",
        "Alpha2Code": "JO",
        "VatCode": "JO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 400
    },
    {
        "Name": "Kazakhstan",
        "Alpha3Code": "KAZ",
        "Alpha2Code": "KZ",
        "VatCode": "KZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 398
    },
    {
        "Name": "Kenya",
        "Alpha3Code": "KEN",
        "Alpha2Code": "KE",
        "VatCode": "KE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 404
    },
    {
        "Name": "Kiribati",
        "Alpha3Code": "KIR",
        "Alpha2Code": "KI",
        "VatCode": "KI",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 296
    },
    {
        "Name": "Korea, Democratic People's Republic of",
        "Alpha3Code": "PRK",
        "Alpha2Code": "KP",
        "VatCode": "KP",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 408
    },
    {
        "Name": "Korea, Republic of",
        "Alpha3Code": "KOR",
        "Alpha2Code": "KR",
        "VatCode": "KR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 410
    },
    {
        "Name": "Kuwait",
        "Alpha3Code": "KWT",
        "Alpha2Code": "KW",
        "VatCode": "KW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 414
    },
    {
        "Name": "Kyrgyzstan",
        "Alpha3Code": "KGZ",
        "Alpha2Code": "KG",
        "VatCode": "KG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 417
    },
    {
        "Name": "Lao People's Democratic Republic",
        "Alpha3Code": "LAO",
        "Alpha2Code": "LA",
        "VatCode": "LA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 418
    },
    {
        "Name": "Latvia",
        "Alpha3Code": "LVA",
        "Alpha2Code": "LV",
        "VatCode": "LV",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.21,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 428
    },
    {
        "Name": "Lebanon",
        "Alpha3Code": "LBN",
        "Alpha2Code": "LB",
        "VatCode": "LB",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 422
    },
    {
        "Name": "Lesotho",
        "Alpha3Code": "LSO",
        "Alpha2Code": "LS",
        "VatCode": "LS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 426
    },
    {
        "Name": "Liberia",
        "Alpha3Code": "LBR",
        "Alpha2Code": "LR",
        "VatCode": "LR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 430
    },
    {
        "Name": "Libya",
        "Alpha3Code": "LBY",
        "Alpha2Code": "LY",
        "VatCode": "LY",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 434
    },
    {
        "Name": "Liechtenstein",
        "Alpha3Code": "LIE",
        "Alpha2Code": "LI",
        "VatCode": "LI",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 438
    },
    {
        "Name": "Lithuania",
        "Alpha3Code": "LTU",
        "Alpha2Code": "LT",
        "VatCode": "LT",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.21,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 440
    },
    {
        "Name": "Luxembourg",
        "Alpha3Code": "LUX",
        "Alpha2Code": "LU",
        "VatCode": "LU",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.16,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 442
    },
    {
        "Name": "Macao",
        "Alpha3Code": "MAC",
        "Alpha2Code": "MO",
        "VatCode": "MO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 446
    },
    {
        "Name": "Macedonia",
        "Alpha3Code": "MKD",
        "Alpha2Code": "MK",
        "VatCode": "MK",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 807
    },
    {
        "Name": "Madagascar",
        "Alpha3Code": "MDG",
        "Alpha2Code": "MG",
        "VatCode": "MG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 450
    },
    {
        "Name": "Malawi",
        "Alpha3Code": "MWI",
        "Alpha2Code": "MW",
        "VatCode": "MW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 454
    },
    {
        "Name": "Malaysia",
        "Alpha3Code": "MYS",
        "Alpha2Code": "MY",
        "VatCode": "MY",
        "TaxRegion": "SGD Non-Taxable",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 458
    },
    {
        "Name": "Maldives",
        "Alpha3Code": "MDV",
        "Alpha2Code": "MV",
        "VatCode": "MV",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 462
    },
    {
        "Name": "Mali",
        "Alpha3Code": "MLI",
        "Alpha2Code": "ML",
        "VatCode": "ML",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 466
    },
    {
        "Name": "Malta",
        "Alpha3Code": "MLT",
        "Alpha2Code": "MT",
        "VatCode": "MT",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.18,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 470
    },
    {
        "Name": "Marshall Islands",
        "Alpha3Code": "MHL",
        "Alpha2Code": "MH",
        "VatCode": "MH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 584
    },
    {
        "Name": "Martinique",
        "Alpha3Code": "MTQ",
        "Alpha2Code": "MQ",
        "VatCode": "MQ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 474
    },
    {
        "Name": "Mauritania",
        "Alpha3Code": "MRT",
        "Alpha2Code": "MR",
        "VatCode": "MR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 478
    },
    {
        "Name": "Mauritius",
        "Alpha3Code": "MUS",
        "Alpha2Code": "MU",
        "VatCode": "MU",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 480
    },
    {
        "Name": "Mayotte",
        "Alpha3Code": "MYT",
        "Alpha2Code": "YT",
        "VatCode": "YT",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 175
    },
    {
        "Name": "Mexico",
        "Alpha3Code": "MEX",
        "Alpha2Code": "MX",
        "VatCode": "MX",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 484
    },
    {
        "Name": "Micronesia",
        "Alpha3Code": "FSM",
        "Alpha2Code": "FM",
        "VatCode": "FM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 583
    },
    {
        "Name": "Moldova",
        "Alpha3Code": "MDA",
        "Alpha2Code": "MD",
        "VatCode": "MD",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 498
    },
    {
        "Name": "Monaco",
        "Alpha3Code": "MCO",
        "Alpha2Code": "MC",
        "VatCode": "MC",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 492
    },
    {
        "Name": "Mongolia",
        "Alpha3Code": "MNG",
        "Alpha2Code": "MN",
        "VatCode": "MN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 496
    },
    {
        "Name": "Montenegro",
        "Alpha3Code": "MNE",
        "Alpha2Code": "ME",
        "VatCode": "ME",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 499
    },
    {
        "Name": "Montserrat",
        "Alpha3Code": "MSR",
        "Alpha2Code": "MS",
        "VatCode": "MS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 500
    },
    {
        "Name": "Morocco",
        "Alpha3Code": "MAR",
        "Alpha2Code": "MA",
        "VatCode": "MA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 504
    },
    {
        "Name": "Mozambique",
        "Alpha3Code": "MOZ",
        "Alpha2Code": "MZ",
        "VatCode": "MZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 508
    },
    {
        "Name": "Myanmar",
        "Alpha3Code": "MMR",
        "Alpha2Code": "MM",
        "VatCode": "MM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 104
    },
    {
        "Name": "Namibia",
        "Alpha3Code": "NAM",
        "Alpha2Code": "NA",
        "VatCode": "NA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 516
    },
    {
        "Name": "Nauru",
        "Alpha3Code": "NRU",
        "Alpha2Code": "NR",
        "VatCode": "NR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 520
    },
    {
        "Name": "Nepal",
        "Alpha3Code": "NPL",
        "Alpha2Code": "NP",
        "VatCode": "NP",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 524
    },
    {
        "Name": "Netherlands",
        "Alpha3Code": "NLD",
        "Alpha2Code": "NL",
        "VatCode": "NL",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.21,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 528
    },
    {
        "Name": "Netherlands Antilles",
        "Alpha3Code": "ANT",
        "Alpha2Code": "AN",
        "VatCode": "AN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 530
    },
    {
        "Name": "New Caledonia",
        "Alpha3Code": "NCL",
        "Alpha2Code": "NC",
        "VatCode": "NC",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 540
    },
    {
        "Name": "New Zealand",
        "Alpha3Code": "NZL",
        "Alpha2Code": "NZ",
        "VatCode": "NZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 554
    },
    {
        "Name": "Nicaragua",
        "Alpha3Code": "NIC",
        "Alpha2Code": "NI",
        "VatCode": "NI",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 558
    },
    {
        "Name": "Niger",
        "Alpha3Code": "NER",
        "Alpha2Code": "NE",
        "VatCode": "NE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 562
    },
    {
        "Name": "Nigeria",
        "Alpha3Code": "NGA",
        "Alpha2Code": "NG",
        "VatCode": "NG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 566
    },
    {
        "Name": "Niue",
        "Alpha3Code": "NIU",
        "Alpha2Code": "NU",
        "VatCode": "NU",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 570
    },
    {
        "Name": "Non-spec Asia Pas Location",
        "Alpha3Code": "AFR",
        "Alpha2Code": "AP",
        "VatCode": "AP",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 901
    },
    {
        "Name": "Norfolk Island",
        "Alpha3Code": "NFK",
        "Alpha2Code": "NF",
        "VatCode": "NF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 574
    },
    {
        "Name": "Northern Mariana Islands",
        "Alpha3Code": "MNP",
        "Alpha2Code": "MP",
        "VatCode": "MP",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 580
    },
    {
        "Name": "Norway",
        "Alpha3Code": "NOR",
        "Alpha2Code": "NO",
        "VatCode": "NO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 578
    },
    {
        "Name": "Oman",
        "Alpha3Code": "OMN",
        "Alpha2Code": "OM",
        "VatCode": "OM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 512
    },
    {
        "Name": "Pakistan",
        "Alpha3Code": "PAK",
        "Alpha2Code": "PK",
        "VatCode": "PK",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 586
    },
    {
        "Name": "Palau",
        "Alpha3Code": "PLW",
        "Alpha2Code": "PW",
        "VatCode": "PW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 585
    },
    {
        "Name": "Palestine",
        "Alpha3Code": "PSE",
        "Alpha2Code": "PS",
        "VatCode": "PS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 275
    },
    {
        "Name": "Panama",
        "Alpha3Code": "PAN",
        "Alpha2Code": "PA",
        "VatCode": "PA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 591
    },
    {
        "Name": "Papua New Guinea",
        "Alpha3Code": "PNG",
        "Alpha2Code": "PG",
        "VatCode": "PG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 598
    },
    {
        "Name": "Paraguay",
        "Alpha3Code": "PRY",
        "Alpha2Code": "PY",
        "VatCode": "PY",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 600
    },
    {
        "Name": "Peru",
        "Alpha3Code": "PER",
        "Alpha2Code": "PE",
        "VatCode": "PE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 604
    },
    {
        "Name": "Philippines",
        "Alpha3Code": "PHL",
        "Alpha2Code": "PH",
        "VatCode": "PH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 608
    },
    {
        "Name": "Pitcairn",
        "Alpha3Code": "PCN",
        "Alpha2Code": "PN",
        "VatCode": "PN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 612
    },
    {
        "Name": "Poland",
        "Alpha3Code": "POL",
        "Alpha2Code": "PL",
        "VatCode": "PL",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.23,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 616
    },
    {
        "Name": "Portugal",
        "Alpha3Code": "PRT",
        "Alpha2Code": "PT",
        "VatCode": "PT",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.23,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 620
    },
    {
        "Name": "Puerto Rico",
        "Alpha3Code": "PRI",
        "Alpha2Code": "PR",
        "VatCode": "PR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 630
    },
    {
        "Name": "Qatar",
        "Alpha3Code": "QAT",
        "Alpha2Code": "QA",
        "VatCode": "QA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 634
    },
    {
        "Name": "Réunion",
        "Alpha3Code": "REU",
        "Alpha2Code": "RE",
        "VatCode": "RE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 638
    },
    {
        "Name": "Romania",
        "Alpha3Code": "ROU",
        "Alpha2Code": "RO",
        "VatCode": "RO",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.21,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 642
    },
    {
        "Name": "Russian Federation",
        "Alpha3Code": "RUS",
        "Alpha2Code": "RU",
        "VatCode": "INN",
        "HasVat": true,
        "TaxRate": 0.2,
        "TaxRegion": "ROW Taxable Russia",
        "Currency": "USD",
        "ShowVatField": false,
        "AlwaysChargeVat": true,
        "Id": 643
    },
    {
        "Name": "Rwanda",
        "Alpha3Code": "RWA",
        "Alpha2Code": "RW",
        "VatCode": "RW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 646
    },
    {
        "Name": "Saint Barthélemy",
        "Alpha3Code": "BLM",
        "Alpha2Code": "BL",
        "VatCode": "BL",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 652
    },
    {
        "Name": "Saint Helena",
        "Alpha3Code": "SHN",
        "Alpha2Code": "SH",
        "VatCode": "SH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 654
    },
    {
        "Name": "Saint Kitts and Nevis",
        "Alpha3Code": "KNA",
        "Alpha2Code": "KN",
        "VatCode": "KN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 659
    },
    {
        "Name": "Saint Lucia",
        "Alpha3Code": "LCA",
        "Alpha2Code": "LC",
        "VatCode": "LC",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 662
    },
    {
        "Name": "Saint Martin (French part)",
        "Alpha3Code": "MAF",
        "Alpha2Code": "MF",
        "VatCode": "MF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 663
    },
    {
        "Name": "Saint Pierre and Miquelon",
        "Alpha3Code": "SPM",
        "Alpha2Code": "PM",
        "VatCode": "PM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 666
    },
    {
        "Name": "Saint Vincent and the Grenadines",
        "Alpha3Code": "VCT",
        "Alpha2Code": "VC",
        "VatCode": "VC",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 670
    },
    {
        "Name": "Samoa",
        "Alpha3Code": "WSM",
        "Alpha2Code": "WS",
        "VatCode": "WS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 882
    },
    {
        "Name": "San Marino",
        "Alpha3Code": "SMR",
        "Alpha2Code": "SM",
        "VatCode": "SM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 674
    },
    {
        "Name": "Sao Tome and Principe",
        "Alpha3Code": "STP",
        "Alpha2Code": "ST",
        "VatCode": "ST",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 678
    },
    {
        "Name": "Saudi Arabia",
        "Alpha3Code": "SAU",
        "Alpha2Code": "SA",
        "VatCode": "SA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 682
    },
    {
        "Name": "Senegal",
        "Alpha3Code": "SEN",
        "Alpha2Code": "SN",
        "VatCode": "SN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 686
    },
    {
        "Name": "Serbia",
        "Alpha3Code": "SRB",
        "Alpha2Code": "RS",
        "VatCode": "RS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 688
    },
    {
        "Name": "SERBIA AND MONTENEGRO",
        "Alpha3Code": "SCG",
        "Alpha2Code": "CS",
        "VatCode": "CS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 891
    },
    {
        "Name": "Seychelles",
        "Alpha3Code": "SYC",
        "Alpha2Code": "SC",
        "VatCode": "SC",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 690
    },
    {
        "Name": "Sierra Leone",
        "Alpha3Code": "SLE",
        "Alpha2Code": "SL",
        "VatCode": "SL",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 694
    },
    {
        "Name": "Singapore",
        "Alpha3Code": "SGP",
        "Alpha2Code": "SG",
        "VatCode": "SG",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.09,
        "TaxRegion": "SGD Taxable",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": true,
        "Id": 702
    },
    {
        "Name": "Sint Maarten (Dutch part)",
        "Alpha3Code": "SXM",
        "Alpha2Code": "SX",
        "VatCode": "SX",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 534
    },
    {
        "Name": "Slovakia",
        "Alpha3Code": "SVK",
        "Alpha2Code": "SK",
        "VatCode": "SK",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.2,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 703
    },
    {
        "Name": "Slovenia",
        "Alpha3Code": "SVN",
        "Alpha2Code": "SI",
        "VatCode": "SI",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.22,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 705
    },
    {
        "Name": "Solomon Islands",
        "Alpha3Code": "SLB",
        "Alpha2Code": "SB",
        "VatCode": "SB",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 90
    },
    {
        "Name": "Somalia",
        "Alpha3Code": "SOM",
        "Alpha2Code": "SO",
        "VatCode": "SO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 706
    },
    {
        "Name": "South Africa",
        "Alpha3Code": "ZAF",
        "Alpha2Code": "ZA",
        "VatCode": "ZA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 710
    },
    {
        "Name": "South Georgia and the South Sandwich Islands",
        "Alpha3Code": "SGS",
        "Alpha2Code": "GS",
        "VatCode": "GS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 239
    },
    {
        "Name": "South Sudan",
        "Alpha3Code": "SSD",
        "Alpha2Code": "SS",
        "VatCode": "SS",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 728
    },
    {
        "Name": "Spain",
        "Alpha3Code": "ESP",
        "Alpha2Code": "ES",
        "VatCode": "ES",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.21,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 724
    },
    {
        "Name": "Sri Lanka",
        "Alpha3Code": "LKA",
        "Alpha2Code": "LK",
        "VatCode": "LK",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 144
    },
    {
        "Name": "Sudan",
        "Alpha3Code": "SDN",
        "Alpha2Code": "SD",
        "VatCode": "SD",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 729
    },
    {
        "Name": "Suriname",
        "Alpha3Code": "SUR",
        "Alpha2Code": "SR",
        "VatCode": "SR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 740
    },
    {
        "Name": "Svalbard and Jan Mayen",
        "Alpha3Code": "SJM",
        "Alpha2Code": "SJ",
        "VatCode": "SJ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 744
    },
    {
        "Name": "Swaziland",
        "Alpha3Code": "SWZ",
        "Alpha2Code": "SZ",
        "VatCode": "SZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 748
    },
    {
        "Name": "Sweden",
        "Alpha3Code": "SWE",
        "Alpha2Code": "SE",
        "VatCode": "SE",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.25,
        "TaxRegion": "EU Taxable",
        "Currency": "EUR",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 752
    },
    {
        "Name": "Switzerland",
        "Alpha3Code": "CHE",
        "Alpha2Code": "CH",
        "VatCode": "CH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 756
    },
    {
        "Name": "Syrian Arab Republic",
        "Alpha3Code": "SYR",
        "Alpha2Code": "SY",
        "VatCode": "SY",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 760
    },
    {
        "Name": "Taiwan",
        "Alpha3Code": "TWN",
        "Alpha2Code": "TW",
        "VatCode": "TW",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 158
    },
    {
        "Name": "Tajikistan",
        "Alpha3Code": "TJK",
        "Alpha2Code": "TJ",
        "VatCode": "TJ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 762
    },
    {
        "Name": "Tanzania",
        "Alpha3Code": "TZA",
        "Alpha2Code": "TZ",
        "VatCode": "TZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 834
    },
    {
        "Name": "Thailand",
        "Alpha3Code": "THA",
        "Alpha2Code": "TH",
        "VatCode": "TH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 764
    },
    {
        "Name": "Timor-Leste",
        "Alpha3Code": "TLS",
        "Alpha2Code": "TL",
        "VatCode": "TL",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 626
    },
    {
        "Name": "Togo",
        "Alpha3Code": "TGO",
        "Alpha2Code": "TG",
        "VatCode": "TG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 768
    },
    {
        "Name": "Tokelau",
        "Alpha3Code": "TKL",
        "Alpha2Code": "TK",
        "VatCode": "TK",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 772
    },
    {
        "Name": "Tonga",
        "Alpha3Code": "TON",
        "Alpha2Code": "TO",
        "VatCode": "TO",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 776
    },
    {
        "Name": "Trinidad and Tobago",
        "Alpha3Code": "TTO",
        "Alpha2Code": "TT",
        "VatCode": "TT",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 780
    },
    {
        "Name": "Tunisia",
        "Alpha3Code": "TUN",
        "Alpha2Code": "TN",
        "VatCode": "TN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 788
    },
    {
        "Name": "Turkey",
        "Alpha3Code": "TUR",
        "Alpha2Code": "TR",
        "VatCode": "TR",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 792
    },
    {
        "Name": "Turkmenistan",
        "Alpha3Code": "TKM",
        "Alpha2Code": "TM",
        "VatCode": "TM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 795
    },
    {
        "Name": "Turks and Caicos Islands",
        "Alpha3Code": "TCA",
        "Alpha2Code": "TC",
        "VatCode": "TC",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 796
    },
    {
        "Name": "Tuvalu",
        "Alpha3Code": "TUV",
        "Alpha2Code": "TV",
        "VatCode": "TV",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 798
    },
    {
        "Name": "Uganda",
        "Alpha3Code": "UGA",
        "Alpha2Code": "UG",
        "VatCode": "UG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 800
    },
    {
        "Name": "Ukraine",
        "Alpha3Code": "UKR",
        "Alpha2Code": "UA",
        "VatCode": "UA",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 804
    },
    {
        "Name": "United Arab Emirates",
        "Alpha3Code": "ARE",
        "Alpha2Code": "AE",
        "VatCode": "AE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 784
    },
    {
        "Name": "United Kingdom",
        "Alpha3Code": "GBR",
        "Alpha2Code": "GB",
        "VatCode": "GB",
        "HasVat": true,
        "HasVatNumber": true,
        "TaxRate": 0.2,
        "TaxRegion": "EU Taxable",
        "Currency": "GBP",
        "ShowVatField": true,
        "AlwaysChargeVat": true,
        "Id": 826
    },
    {
        "Name": "United States",
        "Alpha3Code": "USA",
        "Alpha2Code": "US",
        "VatCode": "US",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 840
    },
    {
        "Name": "Uruguay",
        "Alpha3Code": "URY",
        "Alpha2Code": "UY",
        "VatCode": "UY",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 858
    },
    {
        "Name": "Uzbekistan",
        "Alpha3Code": "UZB",
        "Alpha2Code": "UZ",
        "VatCode": "UZ",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 860
    },
    {
        "Name": "Vanuatu",
        "Alpha3Code": "VUT",
        "Alpha2Code": "VU",
        "VatCode": "VU",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 548
    },
    {
        "Name": "Venezuela",
        "Alpha3Code": "VEN",
        "Alpha2Code": "VE",
        "VatCode": "VE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 862
    },
    {
        "Name": "Vietnam",
        "Alpha3Code": "VNM",
        "Alpha2Code": "VN",
        "VatCode": "VN",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 704
    },
    {
        "Name": "Virgin Islands,British",
        "Alpha3Code": "VGB",
        "Alpha2Code": "VG",
        "VatCode": "VG",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 92
    },
    {
        "Name": "Virgin Islands,U.S",
        "Alpha3Code": "VIR",
        "Alpha2Code": "VI",
        "VatCode": "VI",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 850
    },
    {
        "Name": "Wallis and Futuna",
        "Alpha3Code": "WLF",
        "Alpha2Code": "WF",
        "VatCode": "WF",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 876
    },
    {
        "Name": "Western Sahara",
        "Alpha3Code": "ESH",
        "Alpha2Code": "EH",
        "VatCode": "EH",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 732
    },
    {
        "Name": "Yemen",
        "Alpha3Code": "YEM",
        "Alpha2Code": "YE",
        "VatCode": "YE",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 887
    },
    {
        "Name": "Zambia",
        "Alpha3Code": "ZMB",
        "Alpha2Code": "ZM",
        "VatCode": "ZM",
        "Currency": "USD",
        "ShowVatField": true,
        "AlwaysChargeVat": false,
        "Id": 894
    }
] as const;